import { createContext, FC, PropsWithChildren, useContext } from "react";

import { Theme } from "@mui/material/styles";
import useMuiMediaQuery from "@mui/material/useMediaQuery";

export enum EmailEditorDevice {
  Mobile = "mobile",
  Desktop = "desktop",
}

const EmailEditorDeviceContext = createContext<EmailEditorDevice | null>(null);

const isBelowMd = (theme: Theme) => theme.breakpoints.down("md");

interface EmailEditorDeviceProviderProps {
  device?: EmailEditorDevice;
}

export const EmailEditorDeviceProvider: FC<PropsWithChildren<EmailEditorDeviceProviderProps>> = ({
  device,
  children,
}) => {
  const isMobileViewport = useMuiMediaQuery(isBelowMd, { noSsr: true });
  const resolvedDevice: EmailEditorDevice =
    device ?? (isMobileViewport ? EmailEditorDevice.Mobile : EmailEditorDevice.Desktop);

  return <EmailEditorDeviceContext.Provider value={resolvedDevice}>{children}</EmailEditorDeviceContext.Provider>;
};

export const useEmailEditorDevice = (): EmailEditorDevice => {
  const providedDevice = useContext(EmailEditorDeviceContext);
  const isMobileViewport = useMuiMediaQuery(isBelowMd);

  return providedDevice ?? (isMobileViewport ? EmailEditorDevice.Mobile : EmailEditorDevice.Desktop);
};
